import { StateType } from '../../../../states';
import { getGRLabelsBySkinId } from '../../constants/labels';
import { GRRoundIndexByRoundId } from '../../constants/order';
import { selectGRGlobalSkinId, selectGRGlobalStatus } from '../../selectors/global/globalPrimary.selector';
import { selectGRMiscHomeVisitedIndex } from '../../selectors/misc/miscPrimary.selector';
import { selectGRUserCurrentRoundStatus } from '../../selectors/round.selector';
import { selectGRUserRoundId } from '../../selectors/user/userPrimary.selector';
import { GRRounds } from '../../types/round';
import { GRRoundUserStatuses } from '../../types/user';

const selectUserRoundIndex = (state: StateType) => {
  const userRound = selectGRUserRoundId(state);
  return !userRound ? null : GRRoundIndexByRoundId[userRound] ?? null;
};

const selectIndex = (state: StateType): number => {
  const userRoundIndex = selectUserRoundIndex(state);
  const homeVisitedIndex = selectGRMiscHomeVisitedIndex(state);
  return homeVisitedIndex ?? userRoundIndex ?? 0;
};

const selectHasUserWonLastRound = (state: StateType) => {
  const userRound = selectGRUserRoundId(state);
  const roundStatus = selectGRUserCurrentRoundStatus(state);

  return userRound === GRRounds.SHIRT && roundStatus === GRRoundUserStatuses.WON;
};

const selectEndingValueBySkinId = (state: StateType) => {
  const skinId = selectGRGlobalSkinId(state);
  return getGRLabelsBySkinId(skinId)?.EndingLabel;
};

const selectGRHomeProps = (state: StateType) => {
  const index = selectIndex(state);
  const globalStatus = selectGRGlobalStatus(state);
  const didUserWonLastRound = selectHasUserWonLastRound(state);
  const endingLabel = selectEndingValueBySkinId(state);

  return {
    index,
    globalStatus,
    didUserWonLastRound,
    endingLabel,
  };
};

export default selectGRHomeProps;
